export const valuesStyles = {
    container: {
      padding: "50px 20px",
      fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
      backgroundColor: "#f9f9f9",
    },
    sectionTitle: {
      fontSize: "36px",
      fontWeight: "bold" as const,
      textAlign: "center" as const,
      marginBottom: "40px",
    },
    valuesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "40px",
    maxWidth: "1200px", // Use maxWidth instead of width
    margin: "0 auto", // Center the grid in the container
    justifyContent: "center", // Center items horizontally
    alignContent: "start", // Align items to the start vertically
    textAlign: "center" as 'center'
  },
    valueItem: {
      position: "relative" as const,
      padding: "20px",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      height: "300px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    },
    number: {
      position: "absolute" as const,
      top: "10px",
      left: "10px",
      fontSize: "100px",
      fontWeight: "bold" as const,
      color: "rgba(0, 47, 167, 0.1)", // Light blue color with opacity
      zIndex: 0,
    },
    valueTitle: {
      position: "relative" as const,
      fontSize: "24px",
      fontWeight: "bold" as const,
      color: "#004fa7", // Dark blue color
      zIndex: 1,
      marginBottom: "20px",
      marginTop: "50px"
    },
    valueText: {
      position: "relative" as const,
      fontSize: "16px",
      color: "#333",
      lineHeight: "1.6",
      zIndex: 1,
    },
  };
  
  